import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=3ae103f2"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports